import { FC } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { RootState } from '../../../store/rootReducer';
import Button from '../../Button';

interface IProps {
  setTab: (tab: string) => void;
}

const ClassRetireResult: FC<IProps> = ({
  setTab,
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { chosenClass } = useSelector((state: RootState) => state.class);

  return (
    <>
      <div className="text-left my-2">
        <h5>{chosenClass?.className}</h5>
      </div>

      <div className="mt-5 text-center h5">
        {t('class.class.text16')}<br />
        {t('class.class.text17')}
      </div>
      <div className="row mt-5">
        <div className="col-4">
          <Button
            className="btn btn-sm btn-primary btn-w100p"
            onClick={() => setTab('register')}
            text={t('common.button.list')}
          />
        </div>
        <div className="col-4 text-center">
          <Button
            className="btn btn-sm btn-primary btn-w100p"
            onClick={() => {
              const calculateCode = sessionStorage.getItem('calculateCode');
              if (calculateCode) {
                history.push(`/payment/retire/${calculateCode}/detail`);
              }
            }}
            text={t('class.class.button8')}
          />
        </div>
        <div className="col-4" />
      </div>
    </>
  );
}

export default ClassRetireResult;
